<template>
  <div class="page-container d-flex flex-column flex-grow-1">
    <div v-if="load" class="d-flex flex-grow-1 justify-content-center align-items-center">
      <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div v-else>
      <md-toolbar class="md-medium md-dense">
        <md-button class="md-icon-button md-l mr-4 d-md-none" @click="toggleMenu">
          <md-icon class="text-primary">menu</md-icon>
        </md-button>

        <router-link :to="`/${$route.params.cidade}/home`">
          <img src="../assets/logo/virtex@1.5x.png" class="logo" alt="" />
        </router-link>
        <div class="d-none flex-grow-1 d-md-flex d-sm-none justify-content-end align-items-center">
          <div class="d-flex flex-grow-1 justify-content-center">
            <router-link
            tag="span"
            v-for="item in sharedState.menu"
            :key="item.path"
            :to="linkTo(item.path)"
            >
            <md-button >{{ item.title}}</md-button>
          </router-link>
          <a href="#about-us">
          <md-button >Sobre Nós</md-button>
          </a>

          <a href="https://protocolo.virtex.com.br/">
                <md-button>Meu Protocolo</md-button>
              </a>

          </div>

          <a href="https://virtextelecom.solides.jobs" target="_blank">
            <md-button class="md-primary m-1.5">
              <span class="">Banco de Talentos</span>
            </md-button>
          </a>

          <div class="d-flex flex-column align-items-center p-0 mb-0 mr-3 ml-3">
            <router-link tag="span" to="vtxpay">
              <!-- #019973  #fff/!-->
              <md-button
                style="height: 50px; width: 150px; background: #000; color: #fff; border-radius: 25px;"
                class="md-primary md-elevation-3 d-flex align-items-center justify-content-center md-alignment-space-between"
                md-clickable @click="verifySO()"
              >
                <div>
                  <md-icon style="font-size: 18px; color: #fff;" class="mr-1">payment</md-icon>
                  <span style="font-size: 14px" class="font-weight-bold ">VIRTEX APP</span>
                </div>
                <span style="font-size: 11px;" class="font-weight-bold mt-1 mb-1"
                  >Pague seu Boleto</span
                >
              </md-button>
            </router-link>
          </div>

        <md-button class="md-primary m-0" @click="toClientCenter">Central do Assinante</md-button>
        <CustomSelect
            :options="cityList"
            :default="'Picos - PI'"
            class="select"
            @input="alert(displayToKey($event))"
          />

        </div>
      </md-toolbar>
      <md-drawer class="d-md-none" :md-active.sync="menuVisible" >
        <md-toolbar class="md-primary" md-elevation="0" style="z-index: 10">
          <div class="d-flex flex-grow-1">
            <CustomSelect
            :options="cityList"
            :default="'Picos - PI'"
            class="select"
            @input="alert(displayToKey($event))"
          />
          </div>
          <div class="md-toolbar-section-end">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon>keyboard_arrow_left</md-icon>
            </md-button>
          </div>
        </md-toolbar>
        <md-list>
          <router-link
            tag="span"
            v-for="item in sharedState.menu"
            :key="item.path"
            :to="linkTo(item.path)"
          >
            <md-list-item @click="menuVisible = false">
              <span class="md-list-item-text">{{ item.title }}</span>
            </md-list-item>
          </router-link>

          <span @click="menuVisible = false">
            <md-list-item @click="toClientCenter">
              <span class="md-list-item-text">Central do Assinante</span>
            </md-list-item>
          </span>
          <span @click="menuVisible = false">
            <md-list-item @click="toBancoTalentos">
              <span class="md-list-item-text">Banco de Talentos</span>
            </md-list-item>
          </span>
          <router-link tag="span" to="vtxpay">
            <md-list-item @click="menuVisible = false">
              <span class="md-list-item-text">Pague seu Boleto</span>
            </md-list-item>
          </router-link>
          <span @click="menuVisible = false">
            <md-list-item @click="toProtocolo">
              <span class="md-list-item-text">Meu Protocolo</span>
            </md-list-item>
          </span>

        </md-list>
      </md-drawer>
      <router-view></router-view>
      <footer-botton></footer-botton>
    </div>

  </div>
</template>

<script>
import verifyCityCode from "../scripts/verifyCityCode";
import getCityDataByCode from "../scripts/getCityDataByCode";
import nameCityToCode from "../scripts/nameCityToCode";
import { CITY_SELECT, MAIN } from "../consts/routes";
import { HOME } from "../consts/routes";
import FooterBotton from "../components/FooterBotton";
import getCity from "../scripts/getCitys";
import getUserCityDataByCode from "../scripts/getCityDataByCode";
import getNextCityCode from "../scripts/getNextCityCode";
import { setCityCode } from "../scripts/storageCityCode";
import CustomSelect from "./CustomSelect2";

export default {
  name: "Page",
  components: { FooterBotton, CustomSelect },
  data() {
    return {
      citySelected: "Picos - PI",
      cityList: ["Picos - PI"],
      sharedState: this.$store.state,
      menuVisible: false,
      load: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    linkTo(path) {
      return `/${this.$route.params.cidade}/${path}`;
    },
    toClientCenter() {
      this.$store.dispatch("redirectToClientCenter");
    },
    toProtocolo() {
      this.$store.dispatch("redirectToProtocolo");
    },
    toBancoTalentos() {
      this.$store.dispatch("redirectToBancoTalentos");
    },
    toVTXPay() {
      this.$store.dispatch("redirectToVtxPay");
    },
    verifySO: function() {
      this.result = navigator.platform;
      if (
        this.result == "MacIntel" ||
        this.result == "iPhone" ||
        this.result == "iPad" ||
        this.result == "iPod"
      ) {
        this.$store.dispatch("redirectToAppAppleStore");
      } else {
        this.$store.dispatch("redirectToAppPlayStore");
      }
    },
    changeCity() {
      let { citySelected } = this;
      if (!citySelected) {
        return;
      }

      this.load = true;

      const gucdbc = getUserCityDataByCode(citySelected);

      gucdbc.then(data => {
        this.load = false;
        this.errorLoad = false;
        this.$store.commit("setCityInfo", {
          cityCode: nameCityToCode(data.nomeCidade),
          cityInfo: data
        });
      });

      gucdbc.catch(() => {
        this.load = false;
        this.errorLoad = true;
      });
    }
  },
  created() {
    let cityList = getCity();
    console.log(cityList);
    this.load = true;

    cityList.then(list => {
      this.load = false;
      this.errorLoad = false;
      this.showSnackbarErr = false;
      this.cityList = [...list];
    });

    cityList.catch(() => {
      this.load = false;
      this.showSnackbarErr = true;
      this.errorLoad = true;
    });
  }
};
</script>

<style lang="scss" scoped>
.md-select {
  border: 3px solid #ff0000 !important;
  border-radius: 25px;
}

.md-app-content {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.md-app {
  min-height: 350px;
}

.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}

.logo {
  width: 220px;
  margin: auto;
}
</style>
